import { render, staticRenderFns } from "./ShowDialogTipoProblema.vue?vue&type=template&id=50a3e1c8&scoped=true"
import script from "./ShowDialogTipoProblema.vue?vue&type=script&lang=js"
export * from "./ShowDialogTipoProblema.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogTipoProblema.vue?vue&type=style&index=0&id=50a3e1c8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a3e1c8",
  null
  
)

export default component.exports